import { Component, Input, OnChanges, OnDestroy, OnInit, QueryList, SimpleChange, SimpleChanges, ViewChild, ViewChildren } from "@angular/core";
import { Order } from "../../../../objects/orders/order";
import { OrderItem } from "../../../../objects/orders/orderItem";
import { CanadianCurrencyCode } from "../../../../objects/currencyExchange/canadianCurrencyCode";
import { NgForm } from "@angular/forms";
import { CalculatorAccordion } from "../../accordions/product-accordion/calculator-accordion.component";
import { CalculatorType } from "../../../../objects/orders/calculatorType";
import { OrderOptions } from "../../../../objects/orders/orderOptions";
import { CalculatorHelper } from "../../../../common/helpers/calculatorHelper";
import { OrderStatus } from "../../../../objects/orders/orderStatus";
import { CountryService } from "../../../../services/CountryService";
import { OrderItemOptions } from "../../../../objects/orders/orderItemOptions";
import { CalculatorService } from "../../../../services/calculator/calculatorService";
import { Subscription } from "rxjs/Subscription";

/**
 * Created by vlad.p on 9/8/2017.
 */

@Component({
    selector: "products-card",
    templateUrl: "products-card.component.html",
    moduleId: module.id.toString()
})
export class ProductsCardComponent implements OnInit, OnChanges, OnDestroy {

    @Input()
    public order: Order;

    @Input()
    public canadianCurrencyCodes: CanadianCurrencyCode[];

    @Input()
    public disableChanges: boolean;

    @ViewChild('productsForm')
    public productsForm: NgForm;

    @ViewChildren(CalculatorAccordion)
    public calculatorAccordion: QueryList<CalculatorAccordion>;

    @Input()
    public isPublic: boolean = false;

    public calculatorType = CalculatorType;

    public calculatorHelper = CalculatorHelper;

    public isOneTime: boolean = false;

    public get isQuickQuote(): boolean {
        if(!this.order || !this.order.Flag)
            return false;

        return this.order.Flag.hasFlag(OrderOptions.IsQuickQuote);
    }

    public get isVehicle() : boolean {
        if(!this.order || !this.order.Flag)
            return false;

        return this.order.Flag.hasFlag(OrderOptions.IsVehicle);
    }

    public get isFullQuote(): boolean {
        if(!this.order || !this.order.Flag)
            return true;

        return !this.order.Flag.hasFlag(OrderOptions.IsUsService) &&
            !this.order.Flag.hasFlag(OrderOptions.IsQuickQuote);
    }

    public get isUsService(): boolean {
        if(!this.order || !this.order.Flag)
            return false;

        return this.order.Flag.hasFlag(OrderOptions.IsUsService);
    }

    public get isCanadianCaluclator() : boolean {
        return CalculatorHelper.getCalculatorType(this.order.Locations) == CalculatorType.CanadianImport;
    }

    public get isOcean(): boolean{
       return this.order.Flag != null && this.order.Flag.hasFlag(OrderOptions.IsOcean)
    }

    public set isOcean(val: boolean) {
        if (this.order.Flag != null && this.order.Flag.hasFlag(OrderOptions.IsOcean)) {
            this.order.Flag &= ~OrderOptions.IsOcean;
            this.order.CarryingType = 1;
        } else {
            this.order.Flag |= OrderOptions.IsOcean;
            this.order.CarryingType = 3;
        }
    }

    public orderStatus = OrderStatus;

    public clonedOrderItemsFull: Array<OrderItem> = [];
    public clonedOrderItemsQuick: Array<OrderItem> = [];

    public showChangeQuoteSpinner: boolean = false;
    private subscriptionArray: Array<Subscription> = new Array<Subscription>();

    constructor(private countryService: CountryService, private calculatorService: CalculatorService) {

    }

    public ngOnChanges(changes: SimpleChanges) {
        const name: SimpleChange = changes.isVehicle;

        if(!name || (name.previousValue == name.currentValue))
            return;

        this.showChangeQuoteSpinner = true;
        setTimeout(() => {
            this.showChangeQuoteSpinner = false;
        }, 370); //i need really 370ms, because if faster select 2 hasn't been re-inited yet
    }

    public ngOnInit(): void {
        if (this.order.OrderItems.length == 0)
            this.order.OrderItems.push(new OrderItem({
                CanadianCurrencyCode: CalculatorHelper.getDefaultCurrency(this.canadianCurrencyCodes, this.order, this.countryService)
            }));

        if (this.order.Flag != null && this.order.Flag.hasFlag(OrderOptions.IsOneTime))
            this.isOneTime = true;

        this.subscriptionArray.push(this.calculatorService.subscribe(location => {
            if(!location)
                return;

            if (location.Type == 2) {
                this.handleChange();
            }

            for(let oi of this.order.OrderItems){
                if(!oi.CanadianCurrencyCode || !oi.CanadianCurrencyCode.Name)
                    oi.CanadianCurrencyCode = CalculatorHelper.getDefaultCurrency(this.canadianCurrencyCodes, this.order, this.countryService);
            }
        }));

        this.subscriptionArray.push(this.calculatorService.subscribeIsVeh(isVehicle => {
            this.handleChange();
        }));
    }

    public ngOnDestroy() {
        for(let s of this.subscriptionArray)
            s.unsubscribe();
    }

    private handleChange(): void {
        if(!this.isUsService)
            return;

        if(this.isCanadianCaluclator && this.isVehicle)
            return;

        this.setQuote(0);
    }

    public addProduct(): void {
        this.order.OrderItems.push(new OrderItem({
            CanadianCurrencyCode: CalculatorHelper.getDefaultCurrency(this.canadianCurrencyCodes, this.order, this.countryService)
        }));
    }


    public removeItem(oItem: OrderItem) {
        this.order.OrderItems = this.order.OrderItems.filter(item => item !== oItem);

        if (this.order.OrderItems.length == 0) {
            this.order.OrderItems.push(new OrderItem({
                CanadianCurrencyCode: CalculatorHelper.getDefaultCurrency(this.canadianCurrencyCodes, this.order, this.countryService)
            }));
        }
    }

    public toggleIsOneTime(): void {
        if (this.order.Flag != null && this.order.Flag.hasFlag(OrderOptions.IsOneTime)) {
            this.order.Flag &= ~OrderOptions.IsOneTime;
        } else {
            this.order.Flag |= OrderOptions.IsOneTime;
        }
    }

    public checkForm(): boolean {
        this.productsForm.onSubmit(null);

        if(this.isUsService)
            return true;

        let res = true;

        this.calculatorAccordion.forEach((item) => {
            if (!item.checkForm())
                res = false;
        });
        if (!res)
            return res;

        return this.productsForm.valid;
    }

    public isValid(): boolean {
        if(this.isUsService)
            return true;

        let res = true;

        this.calculatorAccordion.forEach((item) => {
            if (!item.isValid())
                res = false;
        });

        return res;
    }

    public setQuote(value: number): void {
        if (this.order.Status >= OrderStatus.Paid || this.disableChanges)
            return;

        if(value == 2 && !this.isCanadianCaluclator)
            return;

        this.showChangeQuoteSpinner = true;

        if(!this.order.Flag)
            this.order.Flag = 0;

        if (this.order.Flag.hasFlag(OrderOptions.IsQuickQuote)) {
            this.order.Flag &= ~OrderOptions.IsQuickQuote;
            this.clonedOrderItemsQuick = JSON.parse(JSON.stringify(this.order.OrderItems));
        } else if (!this.order.Flag.hasFlag(OrderOptions.IsUsService)) {
            this.clonedOrderItemsFull = JSON.parse(JSON.stringify(this.order.OrderItems));
        }

        this.order.Flag &= ~OrderOptions.IsUsService;

        if (value == 0) {
            this.setQuoteOrderItems(this.order, JSON.parse( JSON.stringify(this.clonedOrderItemsFull)));
        } else if(value == 1) {
            this.order.Flag |= OrderOptions.IsQuickQuote;

            this.setQuoteOrderItems(this.order, JSON.parse(JSON.stringify(this.clonedOrderItemsQuick)));
        } else {
            this.order.Flag |= OrderOptions.IsUsService;

            this.order.OrderItems = [new OrderItem({
                CanadianCurrencyCode: CalculatorHelper.getDefaultCurrency(this.canadianCurrencyCodes, this.order, this.countryService)
            })];
        }

        setTimeout(() => {
            this.showChangeQuoteSpinner = false;
        }, 370); //i need really 370ms, because if faster select 2 hasn't been re-inited yet
    }

    private setQuoteOrderItems(order: Order, clonedOrderItemsFull: Array<OrderItem>): void {
        order.OrderItems = [];

        if (clonedOrderItemsFull.length == 0)
            order.OrderItems = [new OrderItem({
                CanadianCurrencyCode: CalculatorHelper.getDefaultCurrency(this.canadianCurrencyCodes, this.order, this.countryService)
            })];

        for (let it of clonedOrderItemsFull) {
            if (it.Id || (it.Manufacturer && it.Manufacturer.Name ) || it.Price || it.Type > 0 || (it.Product && (it.Product.HsCode || it.Product.Name)) ||
                ((it.FirstNumber || it.Flags > 0 || it.Year) && order.Flag.hasFlag(OrderOptions.IsVehicle) ) ){

                if (!it.CanadianCurrencyCode || !it.CanadianCurrencyCode.Name)
                    it.CanadianCurrencyCode = CalculatorHelper.getDefaultCurrency(this.canadianCurrencyCodes, order, this.countryService);

                order.OrderItems.push(it);
            }
            else
                this.order.OrderItems.push(new OrderItem({
                    CanadianCurrencyCode: CalculatorHelper.getDefaultCurrency(this.canadianCurrencyCodes, order, this.countryService)
                }));
        }
    }

    public isUsServiceTabDisabled(): boolean{
        if(!this.isCanadianCaluclator)
            return true;

        if((this.order.Status >= OrderStatus.Paid || this.disableChanges) && !this.isUsService)
            return true;

        return false
    }

}


// WEBPACK FOOTER //
// ./app/components/calculator/cards/products-card/products-card.component.ts